<template>
  <div>
    <h2>订单明细信息</h2>
    <el-divider></el-divider>
    <div class="tabel-bar">
      <div class="tabel-bar-left">
        <el-button type="primary" :disabled="isDetailDisabled" :size="$store.state.buttonSize" @click="orderInfoPopup()"
          >新增订单明细</el-button
        >
        <RemoveButton
          type="info"
          @click="handleRemoveAll"
          :disabled="!selectionID.length"
          >批量删除</RemoveButton
        >
      </div>
      <div class="tabel-bar-right">
        <el-input
          placeholder="请输入内容"
          :size="$store.state.formSize"
          prefix-icon="el-icon-search"
          v-model="keywords"
          @input="search"
        ></el-input>
        <el-tooltip effect="dark" content="刷新列表" placement="bottom">
          <span
            class="el-icon-refresh icon-hover refresh-btn"
            @click="debounceRefresh"
          ></span>
        </el-tooltip>
      </div>
    </div>
    <el-table v-loading="loading" :data="tableData" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="productName" label="产品名称"></el-table-column>
      <el-table-column prop="batchCode" label="商品条码"></el-table-column>
      <el-table-column prop="productBatch" label="产品批次"></el-table-column>
      <el-table-column label="数量">
        <template slot-scope="scope">{{ scope.row.num }}{{ scope.row.numUnit || '公斤' }}</template>
      </el-table-column>
      <el-table-column prop="remark" label="备注"></el-table-column>
      <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <el-button type="text" @click="orderInfoPopup(scope.row.id)"
            >编辑</el-button
          >
          <el-button type="text" @click="orderInfoDel(scope.row.id)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-size="size"
      :total="total"
    ></pagination>
    <!-- 订单明细表单 -->
    <Dialog :title="title" :visible.sync="orderInfoFormVisible" :with-header="false" center width="85%">
      <el-form
        :model="orderInfoForm"
        :size="$store.state.formSize"
        :rules="orderInfoFormRules"
        ref="refOrderInfoForm"
        label-width="100px"
      >
        <el-form-item label="产品名称：" prop="productId">
          <el-select
            v-model="orderInfoForm.product"
            style="width:100%;"
            filterable
            placeholder="请选择产品"
            @change="setBatch"
          >
            <el-option
              v-for="item in productList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="产品批次：" prop="productBatch">
          <el-select
            v-model="orderInfoForm.productBatch"
            style="width:100%;"
            filterable
            :disabled="batchDisabled"
            placeholder="请选择产品批次"
            @change="setBatchCode"
          >
            <el-option
              v-for="item in productBatchList"
              :key="item.value"
              :label="item.barcode"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="数量：" prop="num">
          <el-input v-model="orderInfoForm.num" autocomplete="off" placeholder="请输入数量">
            <el-select slot="append" v-model="orderInfoForm.numUnit" style="width: 90px;">
              <el-option label="公斤" value="公斤"></el-option>
              <el-option label="吨" value="吨"></el-option>
            </el-select>
          </el-input>
        </el-form-item>
        <el-form-item label="发货信息：">
          <div v-for="(group, index) in shipList" :key="index" class="ship-group">
            <div class="ship-group-bar">
              <el-input
                v-model="group.shipNo"
                :size="$store.state.formSize"
                placeholder="请输入发货运单号"
                maxlength="100"
                style="width: 320px;"
              ></el-input>
              <el-button
                type="text"
                class="ship-group-del"
                @click="removeShipGroup(index)"
                v-if="shipList.length > 1"
              >删除该组</el-button>
            </div>
            <el-upload
              action="#"
              list-type="picture-card"
              :limit="9"
              multiple
              :file-list="group.fileList"
              :http-request="option => handleShipUpload(option, group)"
              :on-remove="(file, fileList) => handleShipRemove(file, fileList, group)"
              :on-exceed="handleShipExceed"
              :before-upload="beforeAvatarUpload"
              :on-preview="handlePictureCardPreview"
            >
              <i slot="default" class="el-icon-plus"></i>
            </el-upload>
          </div>
          <el-button type="text" icon="el-icon-plus" @click="addShipGroup">添加发货运单号</el-button>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input type="textarea" v-model="orderInfoForm.remark"></el-input>
        </el-form-item>
      </el-form>
      <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisible" append-to-body>
        <img width="100%" :src="dialogImageUrl" alt="">
      </el-dialog>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :size="$store.state.buttonSize"
          :disabled="isDisabled"
          @click="debounceSubmit"
          >确 定</el-button
        >
        <el-button :size="$store.state.buttonSize" @click="hanleResetFormVals">取 消</el-button>
      </div>
    </Dialog>
  </div>
</template>
<script>
import moment from 'moment'
import { debounce } from 'throttle-debounce'
import {
  getOrderInfoDetail,
  getOrderInfoList,
  delOrderInfoList,
  deleteOrderInfoDel,
  postOrderInfoEdit,
  putOrderInfoAdd
} from '@/api/order'
import { getBatchmanageProductList } from '@/api/batchmanage'
import { getProductList } from '@/api/product'
import { postWfsImg, wfsImgUrl } from '@/api/common'

const createForm = () => ({
  num: '',
  numUnit: '公斤',
  orderId: null,
  productBatch: null,
  productId: null,
  remark: '',
  productName: ''
})
const createShipGroup = () => ({ shipNo: '', imgs: [], fileList: [] })
export default {
  data() {
    return {
      orderInfoFormVisible: false,
      isDisabled: false,
      batchDisabled: true,
      isInfoDisabled: true,
      total: 0,
      size: 10,
      page: 1,
      keywords: '',
      currentID: null,
      loading: true,
      selectionID: [],
      tableData: [],
      productList: [],
      productBatchList: [],
      orderInfoForm: createForm(),
      orderInfoFormRules: {
        num: [
          { required: true, message: '请输入数量', trigger: 'blur' },
          { pattern: /^\d+(\.\d{1,2})?$/, message: '数量最多保留两位小数', trigger: 'blur' }
        ],
        productBatch: [
          { required: true, message: '请选择产品批次', trigger: 'blur' }
        ],
        productId: [{ required: true, message: '请选择产品', trigger: 'blur' }]
      },
      shipList: [createShipGroup()],
      dialogVisible: false,
      dialogImageUrl: ''
    }
  },
  props: {
    isDetailDisabled: Boolean,
    orderId: Number
  },
  watch: {
    orderId: {
      immediate: true,
      handler(orderId) {
        console.log(orderId)
        this.orderId = orderId
        this.orderInfoForm.orderId = orderId
      }
    }
  },
  computed: {
    title() {
      return this.currentID ? '编辑订单明细' : '新增订单明细'
    }
  },
  created() {
    this.debounceSubmit = debounce(300, this.orderInfoSubmit)
    this.debounceRefresh = debounce(300, this.refresh)
  },
  methods: {
    // 选择产品获取产品批次列表
    setBatch(val) {
      this.batchDisabled = false
      let selectObj = null
      for (let i = 0; i < this.productList.length; i++) {
        selectObj = this.productList.find(item => {
          return item.value === val
        })
      }
      this.orderInfoForm.productId = selectObj.value
      this.getBatchmanageList(selectObj.value)
    },
    setBatchCode(val) {
      let selectObj = null
      for (let i = 0; i < this.productBatchList.length; i++) {
        selectObj = this.productBatchList.find(item => {
          return item.value === val
        })
      }
      this.orderInfoForm.productBatch = selectObj.value
    },
    handleSelectionChange(selection) {
      this.selectionID = selection.map(_ => _.id)
    },
    handleRemoveAll() {
      delOrderInfoList(this.selectionID).then(res => {
        if (res.status === 1) {
          this.$message.success('删除成功')
          this.getOrderInfoListData()
        } else {
          this.$message.error(res.msg)
          return false
        }
      })
    },
    hanleResetFormVals() {
      this.orderInfoFormVisible = false
      this.$set(this, 'orderInfoForm', createForm())
      this.shipList = [createShipGroup()]
      this.$refs.refOrderInfoForm.clearValidate()
    },
    // 发货组：添加/删除
    addShipGroup() {
      this.shipList.push(createShipGroup())
    },
    removeShipGroup(index) {
      this.shipList.splice(index, 1)
    },
    // 发货图片上传（WFS）
    handleShipUpload(option, group) {
      const formData = new FormData()
      formData.append('file', option.file)
      postWfsImg(formData).then(res => {
        if (res.status === 1) {
          group.imgs.push(res.data.filePath)
          group.fileList = group.imgs.map(n => ({ name: n, url: wfsImgUrl(n) }))
        } else {
          this.$message.error(res.msg || '图片上传失败')
          group.fileList = [...group.fileList]
        }
      }).catch(() => {
        this.$message.error('图片上传失败')
        group.fileList = [...group.fileList]
      })
    },
    handleShipRemove(file, fileList, group) {
      const remainNames = fileList.map(f => f.name)
      group.imgs = group.imgs.filter(n => remainNames.indexOf(n) !== -1)
      group.fileList = group.imgs.map(n => ({ name: n, url: wfsImgUrl(n) }))
    },
    handleShipExceed() {
      this.$message.warning('每组最多上传 9 张图片')
    },
    beforeAvatarUpload(file) {
      const isType = /^image\/(jpeg|png|jpg|bmp)$/.test(file.type)
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isType) {
        this.$message.error('请选择图片文件进行上传!')
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
      }
      return isType && isLt2M
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    // 分页
    handleSizeChange(val) {
      this.size = val
      this.getOrderInfoListData()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getOrderInfoListData()
    },
    // 删除订单明细
    orderInfoDel(id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteOrderInfoDel(id).then(res => {
            if (res.status === 1) {
              this.$message.success('删除成功')
              this.getOrderInfoListData()
            } else {
              this.$message.error(res.msg)
              return false
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 提交订单明细表单
    orderInfoSubmit() {
      this.$refs.refOrderInfoForm.validate(valid => {
        if (!valid) return false
        // 组装发货组：完全空的组跳过；有图无订单号的组拦截
        const shipList = []
        for (let i = 0; i < this.shipList.length; i++) {
          const g = this.shipList[i]
          const shipNo = (g.shipNo || '').trim()
          if (!shipNo && g.imgs.length === 0) continue
          if (!shipNo && g.imgs.length > 0) {
            this.$message.error(`第 ${i + 1} 组已上传发货图片，请填写发货运单号`)
            return false
          }
          shipList.push({ shipNo: shipNo, imgs: g.imgs })
        }
        const changeOrderInfo = this.currentID
          ? postOrderInfoEdit
          : putOrderInfoAdd
        changeOrderInfo({
          num: this.orderInfoForm.num,
          numUnit: this.orderInfoForm.numUnit,
          orderId: this.orderId,
          productBatch: this.orderInfoForm.productBatch,
          productId: this.orderInfoForm.productId,
          remark: this.orderInfoForm.remark,
          shipList: shipList,
          id: this.currentID || undefined
        }).then(res => {
          if (res.status === 1) {
            this.currentID
              ? this.$message.success('修改成功')
              : this.$message.success('新增成功')
            this.orderInfoFormVisible = false
            this.getOrderInfoListData()
          } else {
            this.$message.error(res.msg)
            return false
          }
        })
      })
    },
    // 打开订单明细表单
    orderInfoPopup(id) {
      this.orderInfoFormVisible = true
      const isAdd = !id

      if (isAdd) {
        this.currentID = null
        this.shipList = [createShipGroup()]
      } else {
        this.isDisabled = true
        this.currentID = id
        getOrderInfoDetail(id).then(res => {
          console.log(res)
          if (res.status === 1) {
            this.batchDisabled = true
            this.orderInfoForm.num = res.data.num
            this.orderInfoForm.numUnit = res.data.numUnit || '公斤'
            this.orderInfoForm.productBatch = res.data.productBatch
            this.orderInfoForm.productId = res.data.productId
            this.orderInfoForm.remark = res.data.remark
            const ships = res.data.shipList || []
            this.shipList = ships.length
              ? ships.map(g => ({
                shipNo: g.shipNo,
                imgs: [...(g.imgs || [])],
                fileList: (g.imgs || []).map(n => ({ name: n, url: wfsImgUrl(n) }))
              }))
              : [createShipGroup()]
            this.isDisabled = false
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    // 检索
    search() {
      this.getOrderInfoListData()
    },
    // 刷新数据表格
    refresh() {
      this.getOrderInfoListData()
      this.$message.success('数据刷新成功')
    },
    // 获取订单明细列表
    getOrderInfoListData() {
      this.loading = true
      getOrderInfoList({
        page: this.page,
        size: this.size,
        keywords: this.keywords,
        orderId: this.orderId
      }).then(res => {
        if (res.status === 1) {
          if (res.data === null) {
            this.loading = false
          } else {
            this.total = res.data.total
            this.tableData = res.data.rows
          }
        } else {
          this.$message.error(res.msg)
        }
        this.loading = false
      })
    },
    // 产品列表
    getProductListData() {
      getProductList({
        page: 1,
        size: 1000,
        productState: 1
      }).then(res => {
        if (res.status === 1) {
          console.log(res)
          const arr = []
          for (let i = 0; i < res.data.rows.length; i++) {
            arr.push({
              label: res.data.rows[i].productName,
              value: res.data.rows[i].id,
              barcode: res.data.rows[i].barcode
            })
          }
          this.productList = arr
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 产品批次列表
    getBatchmanageList(productId) {
      getBatchmanageProductList({
        page: 1,
        size: 1000,
        productId: productId
      }).then(res => {
        if (res.status === 1) {
          console.log(res)
          const arr = []
          for (let i = 0; i < res.data.rows.length; i++) {
            arr.push({
              label: res.data.rows[i].productName,
              value: res.data.rows[i].id,
              barcode: res.data.rows[i].barcode,
              productId: res.data.rows[i].productId
            })
          }
          this.productBatchList = arr
        } else {
          this.$message.error(res.msg)
        }
      })
    }
  },
  mounted() {
    this.getOrderInfoListData()
    this.getProductListData()
  },
  filters: {
    format(value) {
      return moment(value).format('YYYY-MM-DD HH:mm:ss')
    }
  }
}
</script>
<style lang="scss" scoped>
.ship-group {
  margin-bottom: 12px;
  padding: 10px;
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
}
.ship-group-bar {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.ship-group-del {
  margin-left: 10px;
  color: #f56c6c;
}
</style>
